export const USER_SIGNIN = 'USER_SIGNIN'
export const PASSLIST_REFRESH = 'PASS_LIST_REFRESH'
export const PASSLIST_UPDATE = 'PASS_LIST_UPDATE'
export const PASSLIST_ADD = 'PASS_LIST_ADD'
export const PASSLIST_REMOVE = 'PASS_LIST_REMOVE'
export const LOGOUT_USER = 'LOGOUT_USER'
